import { render, staticRenderFns } from "./homeGoods.vue?vue&type=template&id=44e6058c&scoped=true"
import script from "./homeGoods.vue?vue&type=script&lang=js"
export * from "./homeGoods.vue?vue&type=script&lang=js"
import style0 from "./homeGoods.vue?vue&type=style&index=0&id=44e6058c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6058c",
  null
  
)

export default component.exports